import { useCallback, useState } from 'react';

import { sendFeedback } from 'store/subscriptions/actions';

import { useCancelSubscription, useDispatch, useModals } from 'hooks/index';

import { FeedbackFormValues } from 'types/subscription';
import { ModalName } from 'types/modals';

const useFeedbackSubmission = () => {
  const dispatch = useDispatch();
  const { openModal } = useModals();
  const [isSubmitting, setSubmitting] = useState(false);
  const { onCancelSubscription } = useCancelSubscription();

  const onFeedbackRequested = () => {
    setSubmitting(false);

    openModal(ModalName.SPECIAL_OFFER, { onError: onCancelSubscription });
  };

  const submitFeedback = useCallback(async (data: FeedbackFormValues) => {
    setSubmitting(true);
    dispatch(sendFeedback({ data, onSuccess: onFeedbackRequested, onError: onFeedbackRequested }));
  }, []);

  return { isSubmitting, submitFeedback };
};

export default useFeedbackSubmission;
